import { Box, IconButton, Badge } from '@material-ui/core'
import MuiPopover from '@material-ui/core/Popover'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import * as React from 'react'

import Color from '../base/Color'
import Icons from '../icons/Icons'
import CardNotification, { Notification } from '../molecules/CardNotification'

export type NotificationListsProps = {
  notifications: Notification[]
  allIsRead: boolean
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    notif: {
      borderTopRightRadius: theme.spacing(1),
      borderTopLeftRadius: theme.spacing(1)
    },
    lastStyle: {
      borderBottomLeftRadius: theme.spacing(1),
      borderBottomRightRadius: theme.spacing(1),
      borderBottom: 'none'
    },
    notifText: {
      color: theme.palette.common.black
    },
    notifBadge: {
      marginLeft: theme.spacing(1.5)
    },
    badgeNotif: {
      background: theme.palette.error.main
    },
    iconNotif: {
      color: theme.palette.common.white
    },
    iconBadge: {
      background: theme.palette.common.white
    }
  })
)

const NotificationLists: React.FC<NotificationListsProps> = (props) => {
  const classes = useStyles()
  const { notifications, allIsRead } = props
  const [read, setRead] = React.useState(false)
  const [id, setId] = React.useState(0)
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = (): void => {
    setAnchorEl(null)
  }

  const handleIsRead = (props: number): void => {
    setId(props)
    setRead(true)
  }
  const open = Boolean(anchorEl)
  return (
    <Box>
      <Badge
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        color="primary"
        variant="dot"
        classes={{ badge: classes.iconBadge }}
        invisible={allIsRead}
      >
        <IconButton
          onClick={handleClick}
          size="small"
          className={classes.iconNotif}
        >
          <Icons iconName="NotificationIcon" size="medium" />
        </IconButton>
      </Badge>
      <MuiPopover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <Box overflow="auto" maxHeight={340}>
          {notifications ? (
            notifications.map((notif, index) => {
              return (
                <Box
                  key={`notif-${index}`}
                  borderBottom={`1px solid ${Color.primary[500]}`}
                  className={`
              ${classes.notif} 
              ${index === notifications.length - 1 ? classes.lastStyle : ''}
              `}
                >
                  <CardNotification
                    notification={{
                      id: notif.id,
                      date: notif.date,
                      label: notif.label,
                      link: notif.link
                    }}
                    isRead={id === notif.id ? read : false}
                    onRead={handleIsRead}
                  />
                </Box>
              )
            })
          ) : (
            <Box padding={2}> No Notifications </Box>
          )}
        </Box>
      </MuiPopover>
    </Box>
  )
}

export default NotificationLists
